var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm-.557 16.948l-.042-.692c-.126-1.793.98-3.432 2.728-4.067.643-.226 1.735-.255 2.448-.057.28.085.811.367 1.19.622l.685.466.755-.24c.42-.128.98-.34 1.231-.48.238-.128.448-.198.448-.156 0 .24-.518 1.06-.951 1.511-.588.636-.42.692.77.269.713-.24.727-.24.587.028-.084.141-.518.635-.98 1.087-.783.777-.825.862-.825 1.512 0 1.002-.476 3.093-.951 4.237-.882 2.146-2.77 4.364-4.659 5.48-2.658 1.567-6.197 1.963-9.177 1.045-.993-.311-2.7-1.102-2.7-1.243 0-.043.518-.1 1.147-.113a7.876 7.876 0 003.75-1.045l.755-.452-.868-.297c-1.23-.424-2.336-1.398-2.616-2.316-.084-.297-.056-.31.728-.31l.811-.015-.685-.325c-.812-.41-1.553-1.101-1.917-1.808-.266-.508-.601-1.793-.503-1.892.027-.043.321.042.657.155.965.353 1.091.268.532-.325-1.05-1.073-1.371-2.669-.868-4.18l.238-.678.923.918c1.889 1.85 4.113 2.952 6.66 3.277l.699.084z",
    fill: "currentColor"
  })));
}

export default SvgTwitter;